var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 72,
    viewBox: "0 0 182 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2153 45.7401V26.2338H65.9958V45.7401H61.2153Z",
    fill: "#2A4143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.96 45.7401V26.2338H113.053L121.46 38.1574V26.2338H126.048V45.7401H121.955L113.548 33.8165V45.7401H108.96Z",
    fill: "#2A4143"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.6 45.7402V26.2339H133.381V45.7402H128.6Z",
    fill: "#CC214F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.385 45.7402L143.105 26.2339H148.188L155.908 45.7402H150.962L149.589 41.9488H141.539L140.165 45.7402H135.385ZM142.995 37.9376H148.133L145.55 30.822L142.995 37.9376Z",
    fill: "#CC214F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.375 31.1719L28.0521 44.9062L47.9863 44.9062L45.7968 41.5225",
    stroke: "#CC214F",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1375 37.4593L42.5045 36.4811L41.6551 35.2031",
    stroke: "#CC214F",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7812 28.875C40.7812 30.5836 39.3961 31.9688 37.6875 31.9688C35.9789 31.9688 34.5938 30.5836 34.5938 28.875C34.5938 27.1664 35.9789 25.7812 37.6875 25.7812C39.3961 25.7812 40.7812 27.1664 40.7812 28.875ZM36.7781 28.875C36.7781 29.3773 37.1852 29.7844 37.6875 29.7844C38.1898 29.7844 38.5969 29.3773 38.5969 28.875C38.5969 28.3727 38.1898 27.9656 37.6875 27.9656C37.1852 27.9656 36.7781 28.3727 36.7781 28.875Z",
    fill: "#2A4143"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3294 37.4259L85.6729 45.729H80.4636L77.5661 38.3174H74.0205V45.729H69.2837V26.2513H79.1822C82.4977 26.2513 85.2284 28.9541 85.2284 32.2697C85.2257 33.3051 84.9578 34.3227 84.4503 35.2253C83.9429 36.1279 83.2127 36.8855 82.3294 37.4259ZM80.4622 32.2711C80.4583 31.9324 80.322 31.6087 80.0826 31.3693C79.8431 31.1298 79.5194 30.9935 79.1807 30.9896H74.0205V33.581H79.1822C79.8788 33.581 80.4636 32.9957 80.4636 32.2711H80.4622Z",
    fill: "#2A4143"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.626 35.9492C106.628 37.2595 106.371 38.5572 105.87 39.768C105.369 40.9789 104.635 42.079 103.708 43.0056C102.782 43.9321 101.681 44.6668 100.471 45.1677C99.2598 45.6685 97.9621 45.9256 96.6518 45.9243C91.1629 45.9243 86.6768 41.4661 86.6768 35.9492C86.6768 30.4603 91.1605 25.9741 96.6518 25.9741C102.169 25.9741 106.626 30.4603 106.626 35.9492ZM101.89 35.9492C101.891 35.2611 101.756 34.5796 101.493 33.9437C101.23 33.3078 100.844 32.7301 100.358 32.2435C99.871 31.7569 99.2932 31.3711 98.6573 31.1081C98.0214 30.8452 97.3399 30.7102 96.6518 30.711C93.7818 30.711 91.4136 33.0517 91.4136 35.9492C91.4136 38.8467 93.7818 41.1874 96.6518 41.1874C97.3399 41.1882 98.0214 41.0532 98.6573 40.7902C99.2932 40.5273 99.871 40.1414 100.358 39.6549C100.844 39.1683 101.23 38.5906 101.493 37.9547C101.756 37.3188 101.891 36.6373 101.89 35.9492Z",
    fill: "#2A4143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.77dff56cc61375272e683c94c6431aa1.svg";
export { ForwardRef as ReactComponent };